/**
 * Microsoft Clarity loader — gated by the "statistics" consent category.
 *
 * Nothing runs until the visitor grants statistics cookies via the consent
 * banner. The Clarity snippet is reproduced from the official tag, only
 * wrapped so it executes after consent.
 */

import { whenConsent } from '@/Lib/consent';

const CLARITY_PROJECT_ID = 'xs6jj7fw84';

/** Inject the Clarity tracker once the visitor has granted statistics consent. */
export function initClarity(): () => void {
    return whenConsent('statistics', () => {
        if (typeof window === 'undefined' || typeof document === 'undefined') return;

        const w = window as unknown as { clarity?: (...args: unknown[]) => void; clarity_q?: unknown[] };
        w.clarity =
            w.clarity ||
            function (...args: unknown[]) {
                (w.clarity_q = w.clarity_q || []).push(args);
            } as (...args: unknown[]) => void;

        const t = document.createElement('script');
        t.async = true;
        t.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
        const y = document.getElementsByTagName('script')[0];
        y.parentNode?.insertBefore(t, y);
    });
}